

export class PractitionerTreatmentsUpdate {
    practitionerId: number;
    treatmentIds: number[];
}